module.exports = __webpack_public_path__ + "static/media/heart3.bddfab36.png";